/* eslint-disable jsx-a11y/click-events-have-key-events */
import { AssetIcon } from 'assets/icons/AssetIcon';
import cx from 'classnames';
import Select from 'components/select/Select';
import StartPageButtonIcons from 'components/title-and-logo/StartPageButtonIcons';
import Typography from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { I18N_LOCAL_STORAGE_KEY, I18nNamespace } from 'constants/i18n.const';
import { TIME_CONFIRM_BEFORE_NEXT } from 'constants/photo.const';
import { useBoothAppContext } from 'context/BoothAppContext';
import { useSoundContext } from 'context/SoundContext';
import { emitSeqLog } from 'functions/seq-logging.func';
import { getLocalStorage, setLocalStorage } from 'helpers/common.helper';
import { resourceUrl } from 'helpers/url.helper';
import { useModal } from 'hooks/useModal';
import { useNewPhotoLifeCycleStep } from 'hooks/useNewPhotoLifeCycleStep';
import { useRobotArmHandler } from 'hooks/useRobotArmHandler';
import { useTranslation } from 'hooks/useTranslation';
import i18n from 'i18n';
import { map, size } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { camerasApi } from 'store/api/camera.slice-api';
import {
  resetSelfeAppStateAction,
  setSelfeAppStateAction,
} from 'store/features/app/selfeAppSlice';
import {
  resetTrackingStateAction,
  setTrackingStateAction,
} from 'store/features/app/trackingSlice';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { v4 as uuidv4 } from 'uuid';
import PolicyPopupContent from './PolicyPopupContent';
import './start-page.css';

function StartPage() {
  const { T } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);
  const { audio } = useSoundContext();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { getNextPath } = useNewPhotoLifeCycleStep();
  const { resetArmToHomePosition } = useRobotArmHandler();

  const { boothInfo } = useAppSelector((state) => state.booth);
  const { listLanguage } = useBoothAppContext();
  const { openConfirmModal, closeConfirmModal } = useModal();

  const [language, setLanguage] = useState<string>(
    getLocalStorage(I18N_LOCAL_STORAGE_KEY),
  );

  const handleClickToStartBooth = () => {
    closeConfirmModal();
    const transactionId = uuidv4();
    audio?.playContinueClick?.();
    dispatch(
      setSelfeAppStateAction({
        transactionId,
        isOpenPlaylist: false,
        isConfirmPolicy: true,
      }),
    );
    dispatch(setTrackingStateAction({ LastStartTimePurchase: new Date() }));
    navigate(getNextPath() || '');
    emitSeqLog?.({
      messageTemplate: `[StartPage] ============>`,
    });
  };

  const handleStart = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (!boothInfo) return;

    boothInfo?.IsShowConfirmPolicy
      ? openConfirmModal({
          RenderContent: () => <PolicyPopupContent />,
          onClose: closeConfirmModal,
          onTimeUp: closeConfirmModal,
          className: 'policy-popup-box',
          duration: TIME_CONFIRM_BEFORE_NEXT,
          hidePrev: true,
          NextButtonProps: {
            children: T('agree'),
            color: 'secondary',
          },
          isUseTimer: true,
          onOk: handleClickToStartBooth,
        })
      : handleClickToStartBooth();
  };

  const handleChangeLanguage = useCallback((language: any) => {
    setLanguage(language);
    i18n.changeLanguage(language);
  }, []);

  const langOtp = useMemo(
    () =>
      map(listLanguage, (lang) => ({
        value: lang.code,
        label: (
          <div className="flex items-center gap-5 language-option">
            <img src={resourceUrl(lang.image)} alt="img" />
            {lang.name}
          </div>
        ),
      })),
    [listLanguage],
  );

  useEffect(() => {
    // reset selfe app state cho lượt chụp mới
    dispatch(resetSelfeAppStateAction());
    // reset tracking thời gian các action của KH trên booth
    dispatch(resetTrackingStateAction());
    // check danh sách camera
    dispatch(camerasApi.util.invalidateTags([{ type: 'Camera' }]));
  }, [dispatch]);

  // Reset robot arm to home position when go to start page
  useEffect(() => {
    resetArmToHomePosition();
  }, [resetArmToHomePosition]);

  useEffect(() => {
    if (boothInfo?.LanguageCode) {
      setLanguage(boothInfo.LanguageCode);
      i18n.changeLanguage(boothInfo.LanguageCode);
      setLocalStorage(I18N_LOCAL_STORAGE_KEY, boothInfo.LanguageCode);
    }
  }, [boothInfo?.LanguageCode]);

  return (
    <>
      {size(langOtp) && (
        <Select
          options={langOtp}
          value={language}
          onChange={(value: any) => {
            handleChangeLanguage(value);
          }}
          OuterProps={{
            className: 'change-language-selection',
          }}
        />
      )}
      <div
        className="start-page-title-container w-screen h-screen"
        onClick={handleStart}
      >
        <div className={cx('start-page-title-wrapper text-center')}>
          <button type="button" className="btn-start">
            <AssetIcon.HandClickerIcon className="btn-start-icon-clicker" />
            <Typography
              variant={TYPOGRAPHY_VARIANTS.H1}
              className="start-page-title"
            >
              {T(`${I18nNamespace.COMMON}:touchToStart`)}
            </Typography>
          </button>
          <StartPageButtonIcons />
          <div className="start-page__mascot-placeholder" />
          {/* {numberOfRemain <= NUMER_WARNING_OUT_OF_PAPER && (
            <Typography
              variant={TYPOGRAPHY_VARIANTS.BODY}
              className="number-of-remain"
              data-text={t(`${I18nNamespace.COMMON}:numberOfPrintRemain`)}
            >
              {t(`${I18nNamespace.COMMON}:numberOfPrintRemain`)}:{' '}
              {numberOfRemain}
            </Typography>
          )} */}
        </div>
      </div>
    </>
  );
}

export default StartPage;
